// 透過 @ay-nestjs/share 產生
/* eslint-disable */
import { FetchEventResponseDto } from '../event/dto/fetch-event-response.dto';
import { wsc } from '../wsc';
import { CreateOrUpdateTemplateDto } from './dto/create-template-dto';
import { FetchTemplateListItem } from './dto/fetch-template-list-item.dto';

export class TemplateModel {
  static list(): Promise<FetchTemplateListItem[]> {
    return wsc.execute('/ws/template/list') as any;
  }

  static fetch(hashedEventId: string): Promise<FetchEventResponseDto> {
    return wsc.execute('/ws/template/fetch', hashedEventId) as any;
  }

  static createOrUpdate(body: CreateOrUpdateTemplateDto): Promise<void> {
    return wsc.execute('/ws/template/createOrUpdate', body) as any;
  }

  static delete(hashedEventId: string): Promise<void> {
    return wsc.execute('/ws/template/delete', hashedEventId) as any;
  }
}
// 39f9fd4def2359fa213b3cc0fc4aae9d625d8ab34997668f1aee6641b382c8b7
